import axios from 'axios';

// The whole API sits behind login, so every call to our own backend must carry the session token.
// Patching fetch/axios once here covers raw calls that bypass apiService.

const getTrustedOrigins = () => {
  const origins = new Set([window.location.origin]);
  const apiUrl = window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.API_URL;
  if (apiUrl) {
    try {
      origins.add(new URL(apiUrl, window.location.origin).origin);
    } catch (e) {
      // ignore malformed API_URL
    }
  }
  return origins;
};

const isOwnApiUrl = (url) => {
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.pathname.startsWith('/api/') && getTrustedOrigins().has(parsed.origin);
  } catch (e) {
    return false;
  }
};

const getToken = () => {
  try {
    return localStorage.getItem('token');
  } catch (e) {
    return null;
  }
};

if (typeof window !== 'undefined' && !window.__authFetchInstalled) {
  window.__authFetchInstalled = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const token = getToken();
    if (!token) return originalFetch(input, init);

    const url = typeof input === 'string' ? input : (input && input.url) || String(input);
    if (!isOwnApiUrl(url)) return originalFetch(input, init);

    const headers = new Headers((init && init.headers) || (input && input.headers) || undefined);
    if (!headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return originalFetch(input, { ...(init || {}), headers });
  };

  axios.interceptors.request.use((config) => {
    const token = getToken();
    if (!token) return config;

    const base = config.baseURL || '';
    const fullUrl = /^https?:\/\//i.test(config.url || '') ? config.url : `${base}${config.url || ''}`;
    if (!isOwnApiUrl(fullUrl)) return config;

    if (config.headers && typeof config.headers.has === 'function') {
      if (!config.headers.has('Authorization')) config.headers.set('Authorization', `Bearer ${token}`);
    } else {
      config.headers = config.headers || {};
      if (!config.headers.Authorization && !config.headers.authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  });
}
